import { modalRenderer } from '~/modal/modalRendererRegistry';
import { CustomizeMapUrlContainer } from './customizeMapUrl.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CustomizeMapUrl: undefined;
  }
}
modalRenderer.register('CustomizeMapUrl', CustomizeMapUrlContainer);
